module.exports = __webpack_public_path__ + "img/loaderV3.456874d5.gif";